import { LitElement, html, svg } from 'lit';

export class IconCheck16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Hakemerke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m4 8 3 3 5.5-6"></path></svg>`; }
}
if (!customElements.get('f-icon-check16', IconCheck16)) {
  customElements.define('f-icon-check16', IconCheck16);
}